// middleware/download-locale.ts
export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return;

  // 只拦截 download 页面
  if (!to.path.includes("/download")) return;

  // 当前 URL 里的语言前缀
  const pathLocale = to.path.split("/")[1];

  // 浏览器语言（去掉地区后缀，如 'zh-CN' → 'zh'）
  const browserLang = navigator.language || navigator.languages?.[0] || "en";
  const browserLocale = (browserLang as any).split("-")[0].toLowerCase();

  const config = useRuntimeConfig();
  const locales = config.public.i18n?.locales || [];
  const supportedLocales = locales.map((item) => (item as any).code);
  // 不支持的语言、或语言一致，都不跳转
  if (!supportedLocales.includes(browserLocale)) return;
  if (pathLocale === browserLocale) return;

  // 替换 URL 前缀后重定向
  const newPath = to.path.replace(`/${pathLocale}/`, `/${browserLocale}/`);
  return navigateTo({ path: newPath, query: to.query }, { redirectCode: 302 });
});
